// Sentry must initialize before the React root mounts so the global
// error handlers and the ErrorBoundary fallback are both armed.
import { Sentry } from './lib/sentry';
// The native-origin patch must run BEFORE Better-Auth (or any lib that
// caches a baseURL at import time) loads. Otherwise relative /api/*
// fetches resolve to https://localhost inside Capacitor and every
// request hangs.
import { installNativeApiOrigin } from './lib/api-origin';
installNativeApiOrigin();
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { DialogHost } from './components/DialogHost';
import './index.css';
import { registerServiceWorker } from './lib/pwa';

// Registers the <emoji-picker> custom element. Used by the desktop
// composer; mobile relies on the native OS keyboard's emoji panel.
import 'emoji-picker-element';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

function CrashFallback() {
  return (
    <main className="wide">
      <div className="card">
        <h1>Something broke.</h1>
        <p className="muted">
          We've been notified. You can reload the page — if it keeps happening, please email{' '}
          <a href="mailto:founders@lessalone.app">founders@lessalone.app</a>.
        </p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    </main>
  );
}

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashFallback />}>
      <App />
      {/* DialogHost is the single render target for every
          confirmDialog / promptDialog / alertDialog call across the
          SPA. Mounted as a sibling so it renders at every App state
          (Landing, Onboarding, Rejected, routed pages) — not just
          inside BrowserRouter. */}
      <DialogHost />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

// Register the LessAlone PWA service worker so the browser exposes
// "Add to Home Screen" / standalone display. See lib/pwa.ts.
registerServiceWorker();

// Push permission is requested later — after sign-in + onboarding,
// from App.tsx — so a brand-new user sees the landing page (not the OS
// permission dialog) on first open.
